import { Component } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import * as moment from 'moment';
import { Observable } from 'rxjs';
import { AppConfigService } from '../../../../app-config.service';
import { TypeProjet } from '../../../../shared/constants/type-projet.enum';
import { StatusPreautorisation } from '../../../../shared/modeles/variables';
import { StepEnum } from '../../constants/step.enum';
import {
  GoToStep,
  NavigatePageAnnuleParCoemprunteur,
  NavigatePageFormulaire,
  NavigatePagePreautEnCours,
  PatchDebug
} from '../../state/preautorisation.actions';
import { PreautorisationSelectors } from '../../state/preautorisation.selectors';
import { DEBUG_PREAUTORISATION } from './debug.data';
import { InstitutionEnum } from '../../constants/institution.enum';

@Component({
  selector: 'app-preautorisation-debug',
  templateUrl: './debug.component.html',
  standalone: false
})
export class DebugComponent {
  readonly statusPreautorisationValues = Object.values(StatusPreautorisation);
  readonly stepValues = Object.values(StepEnum).filter(value => typeof value === 'string');
  StepEnum = StepEnum;

  readonly ACCEPTEE_TAUX_EXPIRE = `${StatusPreautorisation.Acceptee} - Taux Expiré`;
  readonly ACCEPTEE_TAUX_30_JOURS = `${StatusPreautorisation.Acceptee} - Taux 30 jours`;
  readonly ACCEPTEE_PREAUT_30_JOURS = `${StatusPreautorisation.Acceptee} - Préaut 30 jours`;

  @Select(PreautorisationSelectors.statutPreautorisation)
  statutPreautorisation$: Observable<StatusPreautorisation>;

  constructor(private readonly _store: Store, private readonly appConfigService: AppConfigService) {}

  private getFutureDate(days: number) {
    return moment()
      .add(days, 'days')
      .toISOString();
  }

  private getPastDate(days: number) {
    return moment()
      .subtract(days, 'days')
      .toISOString();
  }

  changeStatut(value: StatusPreautorisation | string) {
    const preaut = { ...DEBUG_PREAUTORISATION, statut: null };

    if (value === this.ACCEPTEE_TAUX_EXPIRE) {
      preaut.resultat.dateExpiration = this.getFutureDate(180);
      preaut.resultat.taux[0].dateExpirationGarantieTaux = this.getPastDate(30);
    } else if (value === this.ACCEPTEE_TAUX_30_JOURS) {
      preaut.resultat.dateExpiration = this.getFutureDate(180);
      preaut.resultat.taux[0].dateExpirationGarantieTaux = this.getFutureDate(30);
    } else if (value === this.ACCEPTEE_PREAUT_30_JOURS) {
      preaut.resultat.dateExpiration = this.getFutureDate(30);
      preaut.resultat.taux[0].dateExpirationGarantieTaux = this.getPastDate(30);
    } else if (value === StatusPreautorisation.Acceptee) {
      preaut.resultat.dateExpiration = this.getFutureDate(180);
      preaut.resultat.taux[0].dateExpirationGarantieTaux = this.getFutureDate(90);
    }

    if (value.includes(StatusPreautorisation.Acceptee)) {
      preaut.statut = StatusPreautorisation.Acceptee;
    } else {
      preaut.statut = value;
    }

    preaut.type = this.appConfigService.typeProjet;

    this._store.dispatch(new PatchDebug(preaut));
  }

  changeCurrentStep(step: StepEnum) {
    this._store.dispatch(
      new PatchDebug({ ...DEBUG_PREAUTORISATION, statut: null, type: this.appConfigService.typeProjet })
    );
    this._store.dispatch(new GoToStep(step));
    this._store.dispatch(new NavigatePageFormulaire());
  }

  changeTypeEmprunteur(indCoemprunteur: boolean, indCoemprunteurPrincipal: boolean) {
    this._store.dispatch(new PatchDebug({ indCoemprunteur, indCoemprunteurPrincipal }));
  }

  navigatePagePreautEnCours() {
    this._store.dispatch(
      new NavigatePagePreautEnCours(TypeProjet.PremierAcheteur, StatusPreautorisation.Acceptee, InstitutionEnum.Quebec)
    );
  }

  navigatePageAnuleParCoemprunteur() {
    this._store.dispatch(new NavigatePageAnnuleParCoemprunteur());
  }
}
